export interface ApiEnvelope {
  success?: boolean;
  data?: unknown;
}

export function extractData(response: unknown): Record<string, unknown> {
  if (response && typeof response === 'object' && 'data' in response) {
    const envelope = response as ApiEnvelope;

    if (envelope.data && typeof envelope.data === 'object' && !Array.isArray(envelope.data)) {
      return envelope.data as Record<string, unknown>;
    }
  }

  return response && typeof response === 'object' && !Array.isArray(response)
    ? (response as Record<string, unknown>)
    : {};
}

export function extractItems<T>(response: unknown, key = 'items'): T[] {
  const data = extractData(response);
  const candidate = data[key];

  return Array.isArray(candidate) ? (candidate as T[]) : [];
}

